import React from 'react';
import type { PricePlan } from '../../types/content';

// One study plan (e.g. Semi-intensive): lessons, the courses it covers, and the weekly price ladder.
export function PricePlanCard({
  plan
}: {
  plan: PricePlan;
}) {
  const lowest = plan.tiers[plan.tiers.length - 1];
  return <article className="flex flex-col overflow-hidden rounded-[28px] bg-white shadow-card" data-id="element-701" data-mp="2w56suei48u0">
      <header className="bg-brand px-6 py-6 md:px-8" data-id="element-702" data-mp="31e0su40dqra0">
        <h3 className="type-h4 text-white" data-id="element-703" data-mp="31flm7qayk46a">{plan.name}</h3>
        <p className="mt-1 type-card-desc text-white" data-id="element-704" data-mp="36clso2bpz8xx">
          <span className="type-h3 align-middle" data-id="element-705" data-mp="36f7xhu787acg">{plan.lessons}</span> lessons a week · {plan.lessonLength}
        </p>
      </header>

      <div className="px-6 pt-6 md:px-8" data-id="element-706" data-mp="3fdjzesdjluk7">
        {plan.coursesIntro ? <p className="type-small font-semibold text-ink" data-id="element-707" data-mp="3fbpaz432bkbd">{plan.coursesIntro}</p> : null}
        <ul className="mt-2 flex flex-wrap gap-2" data-id="element-708" data-mp="qlg4g30k1n3x">
          {plan.courses.map(course => <li key={course.name} className="rounded-full bg-cream px-3 py-1.5 type-small text-ink" data-id="element-709" data-mp="ulzy2wlx68lb">
              <span className="font-bold" data-id="element-710" data-mp="1gr6ijax2xlx4">{course.name}</span>
              {course.note ? <span className="text-body" data-id="element-711" data-mp="1btn3w9wgz74n"> · {course.note}</span> : null}
            </li>)}
        </ul>
      </div>

      <table className="mt-6 w-full text-left" data-id="element-712" data-mp="16rpcuthtv815">
        <caption className="sr-only" data-id="element-713" data-mp="12sgibmeyr64j">{`${plan.name} weekly prices by course length`}</caption>
        <thead data-id="element-714" data-mp="xskh1uxnhsso">
          <tr className="type-small text-muted" data-id="element-715" data-mp="xt3uozg9pv0w">
            <th scope="col" className="px-6 py-2 font-semibold md:px-8" data-id="element-716" data-mp="xux60s1tt3f8">Course length</th>
            <th scope="col" className="px-6 py-2 text-right font-semibold md:px-8" data-id="element-717" data-mp="t0sudvhm877t">Price per week</th>
          </tr>
        </thead>
        <tbody data-id="element-718" data-mp="j47rpgt2j875">
          {plan.tiers.map((tier, index) => <tr key={tier.weeks} className={index % 2 === 0 ? 'bg-mist' : 'bg-white'} data-id="element-719" data-mp="j5r6t42znd7c" data-mpi={index}>
              <th scope="row" className="px-6 py-3 type-card-desc font-normal text-ink md:px-8" data-id="element-720" data-mp="f1taf151sghz">
                {tier.weeks} weeks
              </th>
              <td className="px-6 py-3 text-right type-h5 text-ink md:px-8" data-id="element-721" data-mp="fvutcv16cm1">{tier.price}</td>
            </tr>)}
        </tbody>
      </table>

      <p className="mt-auto px-6 py-5 type-small text-body md:px-8" data-id="element-722" data-mp="4isihhzfgywu">
        Book 31 weeks or more and pay <span className="font-bold text-ink" data-id="element-723" data-mp="3mof2eajqzj72">{lowest.price}</span> a week.
      </p>
    </article>;
}